import { render } from "./ClientCreate.vue?vue&type=template&id=8d0f7806&scoped=true"
import script from "./ClientCreate.vue?vue&type=script&lang=js"
export * from "./ClientCreate.vue?vue&type=script&lang=js"

import "./ClientCreate.vue?vue&type=style&index=0&id=8d0f7806&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d0f7806"]])

export default __exports__